export default __webpack_public_path__ + "static/media/bench.b0cf9638.svg";